import styled from 'styled-components/macro';
import {spacing} from '@mui/system';

import {
  Typography as MuiTypography,
  Divider as MuiDivider,
  TableRow,
  Stack,
} from '@mui/material';

const Typography = styled(MuiTypography)(spacing);
const Divider = styled(MuiDivider)(spacing);
const StyledTableRow = styled(TableRow)``;
const StyledAction = styled.div``;

const StyledIcon = {
  width: '18px',
  height: '18px',
};
const StyledStack = styled(Stack)`
  margin-right: 10px;
`;
export {
  Typography,
  Divider,
  StyledTableRow,
  StyledAction,
  StyledIcon,
  StyledStack,
};
